import { __decorate, __metadata } from "tslib";
import { IdItemModel, Expose, ItemModelProp, EditorDefinition, CrudEndpoints, ItemModelDefinition, ModelId } from '@core/shared/model';
import { UseRestraints } from '@core/shared/restraints';
import { CompanyDemoRestraints } from "./company-demo.restraints";
import { DemoExtensionStatus } from '../enum/demo-extension-status.enum';
let CompanyDemoItem = /*#__PURE__*/(() => {
  let CompanyDemoItem = class CompanyDemoItem extends IdItemModel {
    toString() {
      return "CompanyDemo " + this.name;
    }
  };
  __decorate([Expose(), __metadata("design:type", Function)], CompanyDemoItem.prototype, "company", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: null
  }), __metadata("design:type", Object)], CompanyDemoItem.prototype, "startDate", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: null
  }), __metadata("design:type", Object)], CompanyDemoItem.prototype, "endDate", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: 0
  }), __metadata("design:type", Number)], CompanyDemoItem.prototype, "extensions", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: DemoExtensionStatus.Granted
  }), __metadata("design:type", String)], CompanyDemoItem.prototype, "extensionStatus", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: null
  }), __metadata("design:type", String)], CompanyDemoItem.prototype, "feedback", void 0);
  CompanyDemoItem = __decorate([EditorDefinition({}, {
    allowAllExposed: true,
    useCrudEndpoint: 'admin'
  }), CrudEndpoints({
    admin: '/admin/users/company-demos'
  }), ItemModelDefinition({
    texts: {}
  }), UseRestraints(CompanyDemoRestraints), ModelId("CompanyDemoItem") // autogenerated by generate-model-ids
  ], CompanyDemoItem);
  return CompanyDemoItem;
})();
export { CompanyDemoItem };